function touchFormFields(state) {
  return Object.entries(state).reduce((result, [key, value]) => {
    return { ...result, [key]: { ...value, isTouched: true } };
  }, {});
}
function touchComposedFormFields(state) {
  return Object.entries(state).reduce((result, [key, value]) => {
    return { ...result, [key]: touchFormFields(value) };
  }, {});
}
export {
  touchComposedFormFields,
  touchFormFields
};
//# sourceMappingURL=touch-form-fields.js.map
